import {IconSizeProps} from "./types";

export default function XverseIcon({
    size=57,
    ...props
}:IconSizeProps) {
    return <svg width={size} height={size} {...props} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <clipPath id="clip0_10280_371492">
                <rect id="svg_1" fill="white" height="57" width="57"/>
            </clipPath>
        </defs>
        <g>
            <title>background</title>
            <rect fill="none" id="canvas_background" height="66" width="66" y="-1" x="-1"/>
        </g>
        <g>
            <title>Layer 1</title>
            <rect id="svg_5" height="64" width="64" rx="8" strokeWidth="0" stroke="#000" fill="#000000"/>
            <g stroke="null" id="svg_2" clipPath="url(#clip0_10280_371492)">
                <path stroke="null" id="svg_3" fill="white"
                      d="m55.71197,55.048143l0,-8.673641c0,-0.343903 -0.136738,-0.671922 -0.380462,-0.915647l-36.905562,-36.905697c-0.243724,-0.243716 -0.571743,-0.380378 -0.915647,-0.380378l-8.673498,0c-0.428207,0 -0.776699,0.348492 -0.776699,0.776699l0,8.058523c0,0.343987 0.136662,0.671922 0.380378,0.915647l13.247168,13.247168c0.30289,0.302974 0.30289,0.794877 0,1.097852l-13.399773,13.39979c-0.145772,0.14573 -0.227773,0.343903 -0.227773,0.548884l0,8.830801c0,0.427946 0.348492,0.776724 0.776699,0.776724l14.493044,0c0.428198,0 0.776724,-0.348778 0.776724,-0.776724l0,-5.20242c0,-0.20498 0.081942,-0.403153 0.227756,-0.548884l7.188436,-7.18852c0.302974,-0.30289 0.794961,-0.30289 1.097852,0l13.33827,13.338438c0.243724,0.243724 0.571743,0.380462 0.915647,0.380462l8.058447,0c0.428282,0 0.77664,-0.348862 0.77664,-0.776724l0.002353,-0.002353z"/>
                <path stroke="null" id="svg_4" fill="#EE7A30"
                      d="m36.37884,19.659638l7.259032,0c0.430467,0 0.781262,0.350795 0.781262,0.781262l0,7.259032c0,0.697051 0.842782,1.045493 1.334768,0.551237l9.958152,-9.974036c0.145562,-0.145814 0.22784,-0.343987 0.22784,-0.551237l0,-8.735034c0,-0.430484 -0.348778,-0.781245 -0.781346,-0.781245l-8.864838,-0.011388c-0.20725,0 -0.405423,0.081992 -0.553506,0.227764l-9.914869,9.89896c-0.491987,0.491903 -0.143461,1.334684 0.551237,1.334684l0.002269,0z"/>
            </g>
        </g>
    </svg>
}